const s = {
  name: "CoreDataStructure",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M0,2h35V0H0V2z"/>
		<path class="st0" d="M0,8h12V6H0V8z"/>
		<path class="st0" d="M40,8H20V6h20V8z"/>
		<path class="st0" d="M38,2h2V0h-2V2z"/>
		<path class="st0" d="M5,38h35v2H5V38z"/>
		<path class="st0" d="M2,38H0v2h2V38z"/>
		<path class="st0" d="M17,8h-2V6h2V8z"/>
		<path class="st0" d="M40,32H28v2h12V32z"/>
		<path class="st0" d="M0,32h20v2H0V32z"/>
		<path class="st0" d="M23,32v2h2v-2H23z"/>
		<path class="st0" d="M14,20c0-3.3,2.7-6,6-6s6,2.7,6,6c0,1.3-0.4,2.5-1.1,3.5l2.8,2.8l-1.4,1.4l-2.8-2.8c-1,0.7-2.2,1.1-3.5,1.1
			C16.7,26,14,23.3,14,20z M20,16c-2.2,0-4,1.8-4,4c0,2.2,1.8,4,4,4s4-1.8,4-4C24,17.8,22.2,16,20,16z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as CoreDataStructure
};
